'use client'

import { useCallback } from 'react'

interface UseSmoothScrollOptions {
  offset?: number
  behavior?: ScrollBehavior
}

export function useSmoothScroll(options: UseSmoothScrollOptions = {}) {
  const { offset = 120, behavior = 'smooth' } = options

  const scrollToElement = useCallback(
    (elementId: string) => {
      const element = document.getElementById(elementId)
      if (!element) return

      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior
      })
    },
    [offset, behavior]
  )

  const scrollToAnchor = useCallback(
    (href: string) => {
      const hashIndex = href.indexOf('#')
      if (hashIndex === -1) return false

      const elementId = href.slice(hashIndex + 1)
      if (hashIndex > 0) return false

      scrollToElement(elementId)
      return true
    },
    [scrollToElement]
  )

  return { scrollToElement, scrollToAnchor }
}
